import { BASE_PATH as h, BaseAPI as T, operationServerMap as C } from "../base.js";
import { DUMMY_BASE_URL as v, assertParamExists as c, createRequestFunction as O, serializeDataIfNeeded as y, setSearchParams as V, toPathString as R } from "../common.js";
import I from "axios";
var A = function(o) {
  return {
    adminCouponIssueBatchIssue: async (r, t = {}) => {
      c("adminCouponIssueBatchIssue", "couponBatchIssueRequestDTO", r);
      const l = new URL("/admin/coupons/batch-issue", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "POST",
        ...n,
        ...t
      }, a = {}, s = {};
      a["Content-Type"] = "application/json", V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, e.data = y(r, e, o), {
        url: R(l),
        options: e
      };
    },
    adminCouponIssueIssue: async (r, t = {}) => {
      c("adminCouponIssueIssue", "couponIssueRequestDTO", r);
      const l = new URL("/admin/coupons/issue", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "POST",
        ...n,
        ...t
      }, a = {}, s = {};
      a["Content-Type"] = "application/json", V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, e.data = y(r, e, o), {
        url: R(l),
        options: e
      };
    },
    adminCouponRuleChangeStatus: async (r, t, l = {}) => {
      c("adminCouponRuleChangeStatus", "ruleId", r), c("adminCouponRuleChangeStatus", "requestBody", t);
      const n = "/admin/coupon-rules/{ruleId}/status".replace("{ruleId}", encodeURIComponent(String(r))), e = new URL(n, v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "PATCH",
        ...a,
        ...l
      }, p = {}, d = {};
      p["Content-Type"] = "application/json", V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...l.headers
      }, s.data = y(t, s, o), {
        url: R(e),
        options: s
      };
    },
    adminCouponRuleCreate: async (r, t = {}) => {
      c("adminCouponRuleCreate", "couponRuleUpsertRequestDTO", r);
      const l = new URL("/admin/coupon-rules", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "POST",
        ...n,
        ...t
      }, a = {}, s = {};
      a["Content-Type"] = "application/json", V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, e.data = y(r, e, o), {
        url: R(l),
        options: e
      };
    },
    adminCouponRuleGet: async (r, t = {}) => {
      c("adminCouponRuleGet", "ruleId", r);
      const l = "/admin/coupon-rules/{ruleId}".replace("{ruleId}", encodeURIComponent(String(r))), n = new URL(l, v);
      let e;
      o && (e = o.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...t
      }, s = {};
      V(n, {});
      let p = e && e.headers ? e.headers : {};
      return a.headers = {
        ...s,
        ...p,
        ...t.headers
      }, {
        url: R(n),
        options: a
      };
    },
    adminCouponRuleList: async (r, t, l, n, e = {}) => {
      const a = new URL("/admin/coupon-rules", v);
      let s;
      o && (s = o.baseOptions);
      const p = {
        method: "GET",
        ...s,
        ...e
      }, d = {}, i = {};
      r !== void 0 && (i.triggerType = r), t !== void 0 && (i.status = t), l !== void 0 && (i.page = l), n !== void 0 && (i.pageSize = n), V(a, i);
      let u = s && s.headers ? s.headers : {};
      return p.headers = {
        ...d,
        ...u,
        ...e.headers
      }, {
        url: R(a),
        options: p
      };
    },
    adminCouponRuleUpdate: async (r, t, l = {}) => {
      c("adminCouponRuleUpdate", "ruleId", r), c("adminCouponRuleUpdate", "couponRuleUpsertRequestDTO", t);
      const n = "/admin/coupon-rules/{ruleId}".replace("{ruleId}", encodeURIComponent(String(r))), e = new URL(n, v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "PUT",
        ...a,
        ...l
      }, p = {}, d = {};
      p["Content-Type"] = "application/json", V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...l.headers
      }, s.data = y(t, s, o), {
        url: R(e),
        options: s
      };
    },
    adminCouponTemplateChangeStatus: async (r, t, l = {}) => {
      c("adminCouponTemplateChangeStatus", "templateId", r), c("adminCouponTemplateChangeStatus", "requestBody", t);
      const n = "/admin/coupon-templates/{templateId}/status".replace("{templateId}", encodeURIComponent(String(r))), e = new URL(n, v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "PATCH",
        ...a,
        ...l
      }, p = {}, d = {};
      p["Content-Type"] = "application/json", V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...l.headers
      }, s.data = y(t, s, o), {
        url: R(e),
        options: s
      };
    },
    adminCouponTemplateCreate: async (r, t = {}) => {
      c("adminCouponTemplateCreate", "couponTemplateUpsertRequestDTO", r);
      const l = new URL("/admin/coupon-templates", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "POST",
        ...n,
        ...t
      }, a = {}, s = {};
      a["Content-Type"] = "application/json", V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, e.data = y(r, e, o), {
        url: R(l),
        options: e
      };
    },
    adminCouponTemplateGet: async (r, t = {}) => {
      c("adminCouponTemplateGet", "templateId", r);
      const l = "/admin/coupon-templates/{templateId}".replace("{templateId}", encodeURIComponent(String(r))), n = new URL(l, v);
      let e;
      o && (e = o.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...t
      }, s = {};
      V(n, {});
      let p = e && e.headers ? e.headers : {};
      return a.headers = {
        ...s,
        ...p,
        ...t.headers
      }, {
        url: R(n),
        options: a
      };
    },
    adminCouponTemplateList: async (r, t, l, n, e = {}) => {
      const a = new URL("/admin/coupon-templates", v);
      let s;
      o && (s = o.baseOptions);
      const p = {
        method: "GET",
        ...s,
        ...e
      }, d = {}, i = {};
      r !== void 0 && (i.type = r), t !== void 0 && (i.status = t), l !== void 0 && (i.page = l), n !== void 0 && (i.pageSize = n), V(a, i);
      let u = s && s.headers ? s.headers : {};
      return p.headers = {
        ...d,
        ...u,
        ...e.headers
      }, {
        url: R(a),
        options: p
      };
    },
    adminCouponTemplateUpdate: async (r, t, l = {}) => {
      c("adminCouponTemplateUpdate", "templateId", r), c("adminCouponTemplateUpdate", "couponTemplateUpsertRequestDTO", t);
      const n = "/admin/coupon-templates/{templateId}".replace("{templateId}", encodeURIComponent(String(r))), e = new URL(n, v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "PUT",
        ...a,
        ...l
      }, p = {}, d = {};
      p["Content-Type"] = "application/json", V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...l.headers
      }, s.data = y(t, s, o), {
        url: R(e),
        options: s
      };
    },
    cashierCouponAvailability: async (r, t, l = {}) => {
      c("cashierCouponAvailability", "couponId", r), c("cashierCouponAvailability", "couponAvailabilityRequestDTO", t);
      const n = "/cashier/coupons/{couponId}/availability".replace("{couponId}", encodeURIComponent(String(r))), e = new URL(n, v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "POST",
        ...a,
        ...l
      }, p = {}, d = {};
      p["Content-Type"] = "application/json", V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...l.headers
      }, s.data = y(t, s, o), {
        url: R(e),
        options: s
      };
    },
    cashierCouponBatchAvailability: async (r, t = {}) => {
      c("cashierCouponBatchAvailability", "couponBatchAvailabilityRequest", r);
      const l = new URL("/cashier/coupons/availability", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "POST",
        ...n,
        ...t
      }, a = {}, s = {};
      a["Content-Type"] = "application/json", V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, e.data = y(r, e, o), {
        url: R(l),
        options: e
      };
    },
    cashierCouponFindByRedeemCode: async (r, t = {}) => {
      c("cashierCouponFindByRedeemCode", "code", r);
      const l = new URL("/cashier/coupons/by-code", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "GET",
        ...n,
        ...t
      }, a = {}, s = {};
      r !== void 0 && (s.code = r), V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, {
        url: R(l),
        options: e
      };
    },
    cashierCouponRedeem: async (r, t, l = {}) => {
      c("cashierCouponRedeem", "couponId", r), c("cashierCouponRedeem", "couponRedeemRequestDTO", t);
      const n = "/cashier/coupons/{couponId}/redeem".replace("{couponId}", encodeURIComponent(String(r))), e = new URL(n, v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "POST",
        ...a,
        ...l
      }, p = {}, d = {};
      p["Content-Type"] = "application/json", V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...l.headers
      }, s.data = y(t, s, o), {
        url: R(e),
        options: s
      };
    },
    memberCouponMyCouponDetail: async (r, t = {}) => {
      c("memberCouponMyCouponDetail", "couponId", r);
      const l = "/member/me/coupons/{couponId}".replace("{couponId}", encodeURIComponent(String(r))), n = new URL(l, v);
      let e;
      o && (e = o.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...t
      }, s = {};
      V(n, {});
      let p = e && e.headers ? e.headers : {};
      return a.headers = {
        ...s,
        ...p,
        ...t.headers
      }, {
        url: R(n),
        options: a
      };
    },
    memberCouponMyCouponPack: async (r, t, l, n = {}) => {
      const e = new URL("/member/me/coupon-pack", v);
      let a;
      o && (a = o.baseOptions);
      const s = {
        method: "GET",
        ...a,
        ...n
      }, p = {}, d = {};
      r !== void 0 && (d.status = r), t !== void 0 && (d.page = t), l !== void 0 && (d.pageSize = l), V(e, d);
      let i = a && a.headers ? a.headers : {};
      return s.headers = {
        ...p,
        ...i,
        ...n.headers
      }, {
        url: R(e),
        options: s
      };
    },
    newMemberBenefitList: async (r, t = {}) => {
      const l = new URL("/me/new-member-benefits", v);
      let n;
      o && (n = o.baseOptions);
      const e = {
        method: "GET",
        ...n,
        ...t
      }, a = {}, s = {};
      r !== void 0 && (s.brandId = r), V(l, s);
      let p = n && n.headers ? n.headers : {};
      return e.headers = {
        ...a,
        ...p,
        ...t.headers
      }, {
        url: R(l),
        options: e
      };
    }
  };
}, m = function(o) {
  const r = A(o);
  return {
    async adminCouponIssueBatchIssue(t, l) {
      var n, e;
      const a = await r.adminCouponIssueBatchIssue(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.adminCouponIssueBatchIssue"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async adminCouponIssueIssue(t, l) {
      var n, e;
      const a = await r.adminCouponIssueIssue(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.adminCouponIssueIssue"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async adminCouponRuleChangeStatus(t, l, n) {
      var e, a;
      const s = await r.adminCouponRuleChangeStatus(t, l, n), p = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, d = (a = C["CouponApi.adminCouponRuleChangeStatus"]) === null || a === void 0 || (a = a[p]) === null || a === void 0 ? void 0 : a.url;
      return (i, u) => O(s, I, h, o)(i, d || u);
    },
    async adminCouponRuleCreate(t, l) {
      var n, e;
      const a = await r.adminCouponRuleCreate(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.adminCouponRuleCreate"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async adminCouponRuleGet(t, l) {
      var n, e;
      const a = await r.adminCouponRuleGet(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.adminCouponRuleGet"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async adminCouponRuleList(t, l, n, e, a) {
      var s, p;
      const d = await r.adminCouponRuleList(t, l, n, e, a), i = (s = o == null ? void 0 : o.serverIndex) !== null && s !== void 0 ? s : 0, u = (p = C["CouponApi.adminCouponRuleList"]) === null || p === void 0 || (p = p[i]) === null || p === void 0 ? void 0 : p.url;
      return (b, S) => O(d, I, h, o)(b, u || S);
    },
    async adminCouponRuleUpdate(t, l, n) {
      var e, a;
      const s = await r.adminCouponRuleUpdate(t, l, n), p = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, d = (a = C["CouponApi.adminCouponRuleUpdate"]) === null || a === void 0 || (a = a[p]) === null || a === void 0 ? void 0 : a.url;
      return (i, u) => O(s, I, h, o)(i, d || u);
    },
    async adminCouponTemplateChangeStatus(t, l, n) {
      var e, a;
      const s = await r.adminCouponTemplateChangeStatus(t, l, n), p = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, d = (a = C["CouponApi.adminCouponTemplateChangeStatus"]) === null || a === void 0 || (a = a[p]) === null || a === void 0 ? void 0 : a.url;
      return (i, u) => O(s, I, h, o)(i, d || u);
    },
    async adminCouponTemplateCreate(t, l) {
      var n, e;
      const a = await r.adminCouponTemplateCreate(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.adminCouponTemplateCreate"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async adminCouponTemplateGet(t, l) {
      var n, e;
      const a = await r.adminCouponTemplateGet(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.adminCouponTemplateGet"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async adminCouponTemplateList(t, l, n, e, a) {
      var s, p;
      const d = await r.adminCouponTemplateList(t, l, n, e, a), i = (s = o == null ? void 0 : o.serverIndex) !== null && s !== void 0 ? s : 0, u = (p = C["CouponApi.adminCouponTemplateList"]) === null || p === void 0 || (p = p[i]) === null || p === void 0 ? void 0 : p.url;
      return (b, S) => O(d, I, h, o)(b, u || S);
    },
    async adminCouponTemplateUpdate(t, l, n) {
      var e, a;
      const s = await r.adminCouponTemplateUpdate(t, l, n), p = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, d = (a = C["CouponApi.adminCouponTemplateUpdate"]) === null || a === void 0 || (a = a[p]) === null || a === void 0 ? void 0 : a.url;
      return (i, u) => O(s, I, h, o)(i, d || u);
    },
    async cashierCouponAvailability(t, l, n) {
      var e, a;
      const s = await r.cashierCouponAvailability(t, l, n), p = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, d = (a = C["CouponApi.cashierCouponAvailability"]) === null || a === void 0 || (a = a[p]) === null || a === void 0 ? void 0 : a.url;
      return (i, u) => O(s, I, h, o)(i, d || u);
    },
    async cashierCouponBatchAvailability(t, l) {
      var n, e;
      const a = await r.cashierCouponBatchAvailability(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.cashierCouponBatchAvailability"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async cashierCouponFindByRedeemCode(t, l) {
      var n, e;
      const a = await r.cashierCouponFindByRedeemCode(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.cashierCouponFindByRedeemCode"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async cashierCouponRedeem(t, l, n) {
      var e, a;
      const s = await r.cashierCouponRedeem(t, l, n), p = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, d = (a = C["CouponApi.cashierCouponRedeem"]) === null || a === void 0 || (a = a[p]) === null || a === void 0 ? void 0 : a.url;
      return (i, u) => O(s, I, h, o)(i, d || u);
    },
    async memberCouponMyCouponDetail(t, l) {
      var n, e;
      const a = await r.memberCouponMyCouponDetail(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.memberCouponMyCouponDetail"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    },
    async memberCouponMyCouponPack(t, l, n, e) {
      var a, s;
      const p = await r.memberCouponMyCouponPack(t, l, n, e), d = (a = o == null ? void 0 : o.serverIndex) !== null && a !== void 0 ? a : 0, i = (s = C["CouponApi.memberCouponMyCouponPack"]) === null || s === void 0 || (s = s[d]) === null || s === void 0 ? void 0 : s.url;
      return (u, b) => O(p, I, h, o)(u, i || b);
    },
    async newMemberBenefitList(t, l) {
      var n, e;
      const a = await r.newMemberBenefitList(t, l), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, p = (e = C["CouponApi.newMemberBenefitList"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (d, i) => O(a, I, h, o)(d, p || i);
    }
  };
}, P = function(o, r, t) {
  const l = m(o);
  return {
    adminCouponIssueBatchIssue(n, e) {
      return l.adminCouponIssueBatchIssue(n.couponBatchIssueRequestDTO, e).then((a) => a(t, r));
    },
    adminCouponIssueIssue(n, e) {
      return l.adminCouponIssueIssue(n.couponIssueRequestDTO, e).then((a) => a(t, r));
    },
    adminCouponRuleChangeStatus(n, e) {
      return l.adminCouponRuleChangeStatus(n.ruleId, n.requestBody, e).then((a) => a(t, r));
    },
    adminCouponRuleCreate(n, e) {
      return l.adminCouponRuleCreate(n.couponRuleUpsertRequestDTO, e).then((a) => a(t, r));
    },
    adminCouponRuleGet(n, e) {
      return l.adminCouponRuleGet(n.ruleId, e).then((a) => a(t, r));
    },
    adminCouponRuleList(n = {}, e) {
      return l.adminCouponRuleList(n.triggerType, n.status, n.page, n.pageSize, e).then((a) => a(t, r));
    },
    adminCouponRuleUpdate(n, e) {
      return l.adminCouponRuleUpdate(n.ruleId, n.couponRuleUpsertRequestDTO, e).then((a) => a(t, r));
    },
    adminCouponTemplateChangeStatus(n, e) {
      return l.adminCouponTemplateChangeStatus(n.templateId, n.requestBody, e).then((a) => a(t, r));
    },
    adminCouponTemplateCreate(n, e) {
      return l.adminCouponTemplateCreate(n.couponTemplateUpsertRequestDTO, e).then((a) => a(t, r));
    },
    adminCouponTemplateGet(n, e) {
      return l.adminCouponTemplateGet(n.templateId, e).then((a) => a(t, r));
    },
    adminCouponTemplateList(n = {}, e) {
      return l.adminCouponTemplateList(n.type, n.status, n.page, n.pageSize, e).then((a) => a(t, r));
    },
    adminCouponTemplateUpdate(n, e) {
      return l.adminCouponTemplateUpdate(n.templateId, n.couponTemplateUpsertRequestDTO, e).then((a) => a(t, r));
    },
    cashierCouponAvailability(n, e) {
      return l.cashierCouponAvailability(n.couponId, n.couponAvailabilityRequestDTO, e).then((a) => a(t, r));
    },
    cashierCouponBatchAvailability(n, e) {
      return l.cashierCouponBatchAvailability(n.couponBatchAvailabilityRequest, e).then((a) => a(t, r));
    },
    cashierCouponFindByRedeemCode(n, e) {
      return l.cashierCouponFindByRedeemCode(n.code, e).then((a) => a(t, r));
    },
    cashierCouponRedeem(n, e) {
      return l.cashierCouponRedeem(n.couponId, n.couponRedeemRequestDTO, e).then((a) => a(t, r));
    },
    memberCouponMyCouponDetail(n, e) {
      return l.memberCouponMyCouponDetail(n.couponId, e).then((a) => a(t, r));
    },
    memberCouponMyCouponPack(n = {}, e) {
      return l.memberCouponMyCouponPack(n.status, n.page, n.pageSize, e).then((a) => a(t, r));
    },
    newMemberBenefitList(n = {}, e) {
      return l.newMemberBenefitList(n.brandId, e).then((a) => a(t, r));
    }
  };
}, w = class extends T {
  adminCouponIssueBatchIssue(o, r) {
    return m(this.configuration).adminCouponIssueBatchIssue(o.couponBatchIssueRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponIssueIssue(o, r) {
    return m(this.configuration).adminCouponIssueIssue(o.couponIssueRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponRuleChangeStatus(o, r) {
    return m(this.configuration).adminCouponRuleChangeStatus(o.ruleId, o.requestBody, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponRuleCreate(o, r) {
    return m(this.configuration).adminCouponRuleCreate(o.couponRuleUpsertRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponRuleGet(o, r) {
    return m(this.configuration).adminCouponRuleGet(o.ruleId, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponRuleList(o = {}, r) {
    return m(this.configuration).adminCouponRuleList(o.triggerType, o.status, o.page, o.pageSize, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponRuleUpdate(o, r) {
    return m(this.configuration).adminCouponRuleUpdate(o.ruleId, o.couponRuleUpsertRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponTemplateChangeStatus(o, r) {
    return m(this.configuration).adminCouponTemplateChangeStatus(o.templateId, o.requestBody, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponTemplateCreate(o, r) {
    return m(this.configuration).adminCouponTemplateCreate(o.couponTemplateUpsertRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponTemplateGet(o, r) {
    return m(this.configuration).adminCouponTemplateGet(o.templateId, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponTemplateList(o = {}, r) {
    return m(this.configuration).adminCouponTemplateList(o.type, o.status, o.page, o.pageSize, r).then((t) => t(this.axios, this.basePath));
  }
  adminCouponTemplateUpdate(o, r) {
    return m(this.configuration).adminCouponTemplateUpdate(o.templateId, o.couponTemplateUpsertRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  cashierCouponAvailability(o, r) {
    return m(this.configuration).cashierCouponAvailability(o.couponId, o.couponAvailabilityRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  cashierCouponBatchAvailability(o, r) {
    return m(this.configuration).cashierCouponBatchAvailability(o.couponBatchAvailabilityRequest, r).then((t) => t(this.axios, this.basePath));
  }
  cashierCouponFindByRedeemCode(o, r) {
    return m(this.configuration).cashierCouponFindByRedeemCode(o.code, r).then((t) => t(this.axios, this.basePath));
  }
  cashierCouponRedeem(o, r) {
    return m(this.configuration).cashierCouponRedeem(o.couponId, o.couponRedeemRequestDTO, r).then((t) => t(this.axios, this.basePath));
  }
  memberCouponMyCouponDetail(o, r) {
    return m(this.configuration).memberCouponMyCouponDetail(o.couponId, r).then((t) => t(this.axios, this.basePath));
  }
  memberCouponMyCouponPack(o = {}, r) {
    return m(this.configuration).memberCouponMyCouponPack(o.status, o.page, o.pageSize, r).then((t) => t(this.axios, this.basePath));
  }
  newMemberBenefitList(o = {}, r) {
    return m(this.configuration).newMemberBenefitList(o.brandId, r).then((t) => t(this.axios, this.basePath));
  }
};
export {
  w as CouponApi,
  A as CouponApiAxiosParamCreator,
  P as CouponApiFactory,
  m as CouponApiFp
};

//# sourceMappingURL=coupon-api.js.map